/**
 * ブランド (brands) の API クライアント。
 *
 * `features/brands/urls.ts` がブランド配下の URL リソースを担当しているのに対し、
 * こちらはブランド本体の一覧取得・作成を担当する。
 *
 * NOTE: 現時点では components/generation/scenario 配下からの呼び出しのみを集約している。
 *       他画面 (pages/brands, pages/products, panels 等) にも同じ生 apiClient 呼び出しが
 *       残っており、そちらの移行は別タスク。
 */
import { apiClient } from '../../services/apiClient';
import type { Brand, CreateBrandPayload } from './types';

export type { Brand, BrandLogo, BrandLogoFile, ECBrandMapping, CreateBrandPayload } from './types';

/**
 * ブランド一覧を取得する。レスポンスは `{ brands: [...] }` 形式。
 */
export async function listBrands(): Promise<{ brands: Brand[] }> {
  const { data } = await apiClient.get<{ brands: Brand[] }>('/brands');
  return data;
}

/**
 * ブランドを作成する。レスポンスは `{ brand: {...} }` 形式。
 */
export async function createBrand(payload: CreateBrandPayload): Promise<{ brand: Brand }> {
  const { data } = await apiClient.post<{ brand: Brand }>('/brands', payload);
  return data;
}
